<div id="tmp-dahsboard">
  <p>
    Nous vous remercions pour votre inscription.<br>
    Vous pouvez désormais discuter avec le chatbot (robot conversationnel) pour découvrir et évaluer vos soft-skills.
  </p>
</div>